import { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../Base/Modal";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 550px;

  .confirmationText {
    font-weight: 700;
    font-size: 32px;
    color: #004576;
  }

  .emailIdToBeDelted {
    margin-top: 15px;
    color: #008ef2;
  }

  .buttonContainer {
    display: flex;
    gap: 20px;

    .button {
      width: 100%;
      background: #004576;
      border-radius: 4px;
      border: none;
      padding: 20px 20px;
      text-align: center;
      color: white;
      margin-top: 20px;
      cursor: pointer;
    }
  }
`;

const AdvisorPortalDeleteInfoConfirmationPopup = ({
  isModalVisible,
  modalOnClose,
  handleYesButtonClick,
  userEmailToDelete,
}) => {
  return (
    <Modal show={isModalVisible} onClose={modalOnClose}>
      <Wrapper>
        <div className="confirmationText">
          Are you sure you would like to remove this user?
        </div>
        <div className="emailIdToBeDelted">{userEmailToDelete}</div>
        <div className="buttonContainer">
          <button className="button" onClick={handleYesButtonClick}>
            Yes
          </button>
          <button className="button" onClick={modalOnClose}>
            No
          </button>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default AdvisorPortalDeleteInfoConfirmationPopup;
